import { Link } from "react-router-dom"
import { ActiveSiteLink } from "../services/webb-utilities"

import icon from '../media/icon.png'
import avtr from '../media/user.png'

export default function HeaderInner(props) {

  return (
    <>
    <div className="sticky-top border-bottom bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-1 d-none d-lg-block"></div>
          <div className="col">
            <div className="d-flex justify-content-between py-2">
              <div className="py-2">
                <img 
                  src={icon} 
                  width="33" height="33" alt="..."
                  className=""
                ></img>
              </div>
              <div className="py-2">
                <p className="lead m-0 p-0">{props.name}</p>
              </div>

              <div className="">
                <Link to={props.link} className="">
                  <i className="bi-x text-muted" style={{fontSize:'2rem'}}></i>
                </Link>
              </div>
            </div>

          </div>
          <div className="col-lg-1 d-none d-lg-block"></div>
        </div>
      </div>  
    </div>
    
    </>
  )
}